import React from 'react';
import { useSelector } from 'react-redux';
import Basket from '../../lib/basket';
import { NormalText } from '../common';
import './index.css';
import { warningOutline } from 'ionicons/icons';
import { IonIcon } from '@ionic/react';

const MESSAGES = {
	delivery: 'Minimum order for delivery is {minOrder}. Add {remaining} more to continue.',
	collection: 'Minimum order for collection is {minOrder}. Add {remaining} more to continue.',
	table: 'Minimum order for table service is {minOrder}. Add {remaining} more to continue.',
	default: 'Minimum order is {minOrder}. Add {remaining} more to continue.',
};

const ORDER_TYPE_MESSAGES = {
	'delivery': MESSAGES.delivery,
	'charter-delivery': MESSAGES.delivery,
	'scheduled-delivery': MESSAGES.delivery,
	'collection': MESSAGES.collection,
	'scheduled-collection': MESSAGES.collection,
	'pick-up-at-counter': MESSAGES.default,
	'pick-up-point': MESSAGES.default,
	'table': MESSAGES.table,
};

const MinimumOrderBanner = ({ __ }) => {
	// keeps the banner in sync with every basket change
	useSelector((state) => state.orders.basketUpdated);

	if (parseFloat(Basket.getTotal()) === 0) {
		return null;
	}

	// same rules as Basket.isMinimumOrderTotalSatisfied
	const minDeliveryOrder = parseFloat(Basket.getDeliveryMinOrder());
	const minOrderValue = parseFloat(Basket.getMinOrder());
	const minOrder = minDeliveryOrder > 0 ? minDeliveryOrder : minOrderValue;
	const total = parseFloat(minDeliveryOrder > 0 ? Basket.getSubTotal() : Basket.getTotal());

	if (!(minOrder > 0) || !(minOrder > total)) {
		return null;
	}

	const message = ORDER_TYPE_MESSAGES[Basket.order_type] || MESSAGES.default;

	return (
		<div className="minimum-order-banner box-wrapper">
						<IonIcon color="warning" icon={warningOutline} />

			<NormalText className="minimum-order-banner-text">
				{__(message, {
					minOrder: Basket.formatPrice(minOrder),
					remaining: Basket.formatPrice(Basket.round(minOrder - total, 2)),
				})}
			</NormalText>
		</div>
	);
};

export default MinimumOrderBanner;
